import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, CustomLoginGuard, FeaturesConfigModule, I18nModule, NotAuthGuard } from "@spartacus/core";
import { GlobalMessageComponentModule, FormErrorsModule, PasswordVisibilityToggleModule, SpinnerModule, CmsPageGuard, PageLayoutComponent } from "@spartacus/storefront";
import { RouterModule } from '@angular/router';
import { UrlModule } from '@spartacus/core';
import { KbLoginComponent } from './kb-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { BackofficeEmailPasswordChangerComponent } from './backoffice-email-password-changer/backoffice-email-password-changer.component';
import { BackofficeEmailSenderComponent } from './backoffice-email-sender/backoffice-email-sender.component';

const List = [
  BackofficeEmailPasswordChangerComponent,
  BackofficeEmailSenderComponent,
  KbLoginComponent,
  ForgotPasswordComponent
];
@NgModule({
  declarations: [
    KbLoginComponent,
    ForgotPasswordComponent,
    List
  ],
  providers: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    PasswordVisibilityToggleModule,
    GlobalMessageComponentModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    FeaturesConfigModule,
    RouterModule.forChild([
      {
        path: 'login/pw/backofficepasschange',
        data: { pageLabel: '/login' },
        component: BackofficeEmailPasswordChangerComponent,
        canActivate: [CmsPageGuard, SecureGuard],
      },
      {
        path: 'login/pw/requestbackofficeuser',
        data: { pageLabel: '/login' },
        component: BackofficeEmailSenderComponent,
        canActivate: [CmsPageGuard, SecureGuard],
      }
    ]),
    ConfigModule.withConfig({
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: KbLoginComponent,
          guards: [NotAuthGuard, CustomLoginGuard],
        },
      }
    } as CmsConfig)
  ],
  exports: [List],
})
export class KbLoginModule { }
